export default "__VITE_ASSET__BDCd_cfN__"